import { render } from "./CrudCliente.vue?vue&type=template&id=47bb95fa"
import script from "./CrudCliente.vue?vue&type=script&lang=ts"
export * from "./CrudCliente.vue?vue&type=script&lang=ts"
script.render = render

export default script